<div class="modal-header">
  <h4 class="modal-title float-left">{{ "editSignatory.title" | translate }}</h4>
</div>

<div class="modal-body">
    <div class="form-group mb-3">
        <label for="nameInput" class="fw-bold ">{{ 'contacts.name' | translate }} *</label>
        <input class="form-control" id="nameInput"
        type="text"
        [formControl]="nameInputControl" />
    </div>

    <div class="form-group mb-3">
      <label for="emailInput" class="fw-bold ">{{ 'signrequest.email_address' | translate }} *</label>
      <input id="emailInput" class="form-control"
        [formControl]="emailInputControl" />
    </div>

    <hr />

    <div class="form-group mb-3">
        <label for="authMethods">{{ 'signrequest.authentication' | translate }}</label>

        <app-auth-methods (toggle)="toggleAuthentication($event)"
                          [enabled]="enabledAuthenticationMethods"
                          [disabled]="disabledAuthenticationMethods"
                          [exclusive]="undefined"
                          [signatory]="signatory"
                          id="authMethods">
        </app-auth-methods>
    </div>

    <div class="ms-3 border-start ps-3">

       @if (hasMethod('SMSTAN', 'PREVIEW') || hasMethod('SMS', 'AFTERVIEW')) {
        <div class="ms-4 mb-3 ">
            <div class="mb-2">{{ 'contacts.phone' | translate }}*</div>
            <small class="text-muted">{{'signrequest.phone_smstan' | translate}}</small>
            <input class="form-control" [formControl]="phoneControl">
        </div>
        }

        @if (hasMethod('CSC', 'AFTERVIEW')) {
            <div class="mb-2"><strong>{{ 'signrequest.cscProviders' | translate }}*</strong></div>
            @for ( provider of enabledProviders; track provider.id) {
            <div class="d-flex align-items-center mb-2">
                <div class="checkbox c-checkbox">
                    <label class="mb-0">
                        <input type="checkbox"
                               [id]="provider.id"
                               [checked]="provider.selected"
                               (change)="provider.selected = !provider.selected;">
                        <span class="fa fa-fw fa-check"></span>
                    </label>
                </div>

                <div style="padding-left: 10px;">
                    <label style="font-weight: normal; font-style: italic;" class="mb-0" [for]="provider.id">
                        {{ provider.name }}
                    </label>
                </div>

            </div>
            }
        }
    </div>



    @if (serverMsg) {
    <div class="alert alert-danger mt-3 small">
      {{ serverMsg }}
    </div>
    }

    <div class="d-flex mt-4">
        <button class="btn btn-outline-danger" (click)="bsModalRef.hide()">{{ 'signrequest.close' | translate }}</button>
        <div class="flex-grow-1"></div>
        <button class="btn btn-secondary px-4"
          (click)="updateSignatory()"
          [disabled]="nameInputControl.invalid || emailInputControl.invalid || phoneControl.invalid || areMethodsInvalid()">
          {{ 'common.save' | translate }}
        </button>
      </div>
</div>
